import Grid from "@mui/material/Grid";
import React from "react";
import NewButton from "../Buttons/NewButton";
import strings from "../../config/localization";
import Header from "./Header";
import Line from "./Line";

export default function Plane(props) {
  console.log("Plane, props:", props);

  const onDelete = (index) => {
    console.log("onDelete, props.data:", props.data);
    console.log("onDelete, index:", index);
    const new_state = [...props.data];
    new_state.splice(index, 1);
    console.log("onDelete, new_state:", new_state);
    props.onChange(new_state);
  };

  const onAdd = () => {
    props.onAdd([...props.data]);
  };

  const onChange = (index, values) => {
    console.log(`onChange, index: ${index}, values: ${values}`);
    const new_state = [...props.data];
    new_state[index] = values;
    console.log("onChange, new_state:", new_state);
    props.onChange(new_state);
  };

  return (
    <>
      <Grid container spacing={0}>
        {/* {props.validationErrors && (
          <Grid item xs={12}>
            <ErrorMsg title={""} msg={props.validationErrors} />
          </Grid>
        )} */}
        <Grid item xs={12}>
          <Header metaData={props.metaData} />
        </Grid>
        {props.data.map((datum, index) => {
          console.log("Plane, datum:", datum);
          return (
            <>
              <Grid item xs={12} key={index}>
                <Line
                  index={index}
                  metaData={props.metaData}
                  data={datum}
                  onDelete={onDelete}
                  onChange={onChange}
                />
              </Grid>
            </>
          );
        })}
        <Grid item xs={12}>
          <NewButton
            id={"newButton2"}
            size="small"
            label={strings.add}
            onClickHandler={onAdd}
          />
        </Grid>
      </Grid>
    </>
  );
}
